import React, { Fragment, useEffect } from 'react';
import useTranslateController from '../Hooks/useTranslateController';
import { useSelector } from 'react-redux';
import { PERMISSIONS } from '../../Auth/Constants/constants';

const TranslateDOM = () => {
  const { extractAndTransformText, translate, getTranslationValue } = useTranslateController();
  const activeLanguage = useSelector((state) => state.localization?.selectedLanguage);
  const permissions = useSelector((state) => state.auth.user.permissions);
  const isLocalizationEnabled = permissions?.includes(PERMISSIONS.ENABLE_LOCALIZATION);

  useEffect(() => {
    if (!isLocalizationEnabled) {
      return;
    }
    // translation api call and updating dom with translated data
    const handleDomChanges = (mutationsList, observer) => {
      observer.disconnect();
      const textNodes = [];
      if (activeLanguage?.value !== 'en') {
        mutationsList.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              const useTranslation = getTranslationValue(node);
              extractAndTransformText(node, textNodes, useTranslation);
            });
          }
        });

        const texts = textNodes.map(([node, _]) => node.textContent);
        if (texts.length > 0) {
          translate({ data: { texts, target_lang: activeLanguage?.value } }).then((data) => {
            textNodes.forEach(([node, parent]) => {
              node.textContent = data[node.textContent] || node.textContent;
              parent.setAttribute('data-text-translated', node.textContent);
              parent.style.filter = 'none';
            });
          });
        }
      }

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
      });
    };

    const observer = new MutationObserver(handleDomChanges);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
    });
    return () => observer.disconnect();
  }, [extractAndTransformText, translate, getTranslationValue, activeLanguage?.value, isLocalizationEnabled]);

  return <Fragment></Fragment>;
};

export default TranslateDOM;
